export var ModalIds;
(function (ModalIds) {
    ModalIds["CONTACT"] = "CONTACT_FORM";
    ModalIds["PRICE"] = "SUGGEST_PRICE";
    ModalIds["MASONRY"] = "IMAGES_MASONRY";
    ModalIds["SLIDER"] = "IMAGES_FULLSCREEN";
    ModalIds["ENERGY"] = "ENERGY";
    ModalIds["FEATURES"] = "FEATURES";
    ModalIds["MEDIA"] = "MEDIA_FULLSCREEN";
    ModalIds["MULTI_INQUIRY"] = "MULTI_INQUIRY";
    ModalIds["CALL_TRACKING"] = "CALL_TRACKING";
    ModalIds["MOBILE_LEGAL_NOTICE_SECTION"] = "MOBILE_LEGAL_NOTICE_SECTION";
    ModalIds["PRIVACY_POLICY"] = "PRIVACY_POLICY";
    ModalIds["TAG_INFO"] = "TAG_INFO";
    ModalIds["PERSONAL_DATA"] = "PERSONAL_DATA";
})(ModalIds || (ModalIds = {}));
